import { SearchType } from '@aibees/elephant/types';
import { SearchFilterBase } from '../types';
import certificationFilterConfig from './certification';
import companyInfoFilterConfig from './company-info';
import educationFilterConfig from './education';
import jobRoleFilterConfig from './job-role';
import keywordsFilterConfig from './keywords';
import lablesFilterConfig from './labels';
import languageSkillsFilterConfig from './language-skills';
import listsFilterConfig from './lists';
import locationFilterConfig from './location';
import locationsWorldwideFilterConfig from './locations-worldwide';
import peopleInfoFilterConfig from './people-info';
import profileBadgeFilterConfig from './profile-badge';
import recordsOwnershipFilterConfig from './recrods-ownership';
import skillsFilterConfig from './skills';

const filters: SearchFilterBase[] = [
  listsFilterConfig(SearchType.People, true),
  peopleInfoFilterConfig(),
  jobRoleFilterConfig(),
  keywordsFilterConfig(SearchType.People, true),
  profileBadgeFilterConfig(),
  locationFilterConfig(SearchType.People, true),
  skillsFilterConfig(),
  educationFilterConfig(),
  // socialMediaFilterConfig(SearchType.People), // todo: uncomment this after the social media filter for contacts is implemented
  companyInfoFilterConfig(),
  lablesFilterConfig(SearchType.People, true),
  recordsOwnershipFilterConfig(SearchType.People),
  languageSkillsFilterConfig(),
  certificationFilterConfig(),
  locationsWorldwideFilterConfig(),
];

export default filters;
